import PersonSurveyBaseController from './person_survey_base_controller';

export default class extends PersonSurveyBaseController {
    connect() {
        super.connect?.();

        const form = document.querySelector('#survey-step-form')
        if (!form) return;

        this.setupNavigation(form);
        this.handleCurrentStep(form);
    }

    handleCurrentStep(form) {
        const step_class = Array.from(form.classList).find(c => c.startsWith('step-'));
        this.step = Number(step_class?.split('-')[1]);
        const handlers = {
            '1': () => this.handleStep1(),
            '2': () => this.handleStep2(),
            '3': () => this.handleStep3(),
            '4': () => this.handleStep4(),
            '5': () => this.handleStep5(),
            '6': () => this.handleStep6(),  // handled additionally by PersonSurveyTimeTable
            '7': () => this.handleStep7(),       // handled additionally by PersonSurveyTimeTable
        };

        handlers[this.step]?.();
    }

    handleStep1 = () => {
    }

    handleStep2 = () => {
    }


    handleStep3 = () => {
    }

    handleStep4 = () => {
        this.setupResetButton();
    }

    handleStep5 = () => {
        // wait until 'materializecss-init' stimulus controller is registered
        setTimeout(_ => this.reInitializeMaterializeCss(), 500);
    }

    handleStep6 = () => {
        this.setupResetButton();
        this.setupTimeWishToggle();
    }

    handleStep7 = () => {
        this.setupResetButton();
    }

}